import React from "react";
import { compose } from "redux";
import {
  Container,
  Text,
  withStyles,
  withBreakpoint,
  Md,
  Xs
} from "../../common";
import tomocard from "../../../assets/tomo_vert_card.png";

const CurrentBalance = () => (
  <>
    <Xs to="md">
      <div className="w-full h-full">
        <Container className="w-full flex-1 h-full justify-center">
          <div className="flex flex-col items-center text-center">
            <Text title>Current Balance</Text>
            <Text className="text-2xl md:text-3xl mt-2" weight="light">
              $0.00
            </Text>
          </div>
        </Container>
      </div>
    </Xs>
    <Md>
      <Container className="w-full justify-center">
        <div className="flex flex-col md:flex-row pt-1 pb-2 md:py-0">
          <div className="flex mt-2 md:mt-0 balance-card-m md:balance-card-d mx-auto md:mx-0 md:pl-1 mb-5 md:mb-0">
            <div className="md:block">
              <img
                alt="tomo-card"
                className="md:w-8/12 w-full mx-auto"
                src={tomocard}
              />
            </div>
          </div>
          <div className="flex flex-col justify-center md:pl-6 md:text-left text-center">
            <Text className="pb-1 text-2xl md:text-xl" title>
              Current Balance
            </Text>
            <Text size="3xl" weight="light">
              $0.00
            </Text>
          </div>
        </div>
      </Container>
    </Md>
  </>
);

export default compose(
  withStyles,
  withBreakpoint
)(CurrentBalance);
